module.exports = __webpack_public_path__ + "assets/images/620884d713bd48ca2d5b9f3857694547.png";